import { connect } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';

const RouteSummaryGridPanel = ({ routeSummaryData, filters, customers }) => {

    const enrichedRows = (routeSummaryData || []).map(row => ({
        ...row,
        filter_date: row.scan_date || '',
        filter_customer: (() => {
            const c = (customers || []).find(c => c.customer_id === filters.customer);
            return c ? c.customer_name : (filters.customer || '');
        })(),
        filter_dc: row.dc_name || filters.dc || '',
        pallets_expected: row.total_pallets || 0
    }));

    const columns = [
        { field: 'filter_date', headerName: 'Date', width: 110, valueFormatter: (params) => {
            if (!params.value) return '';
            const [y, m, d] = params.value.split('-');
            return `${m}-${d}-${y}`;
        } },
        { field: 'filter_customer', headerName: 'Customer', width: 160 },
        { field: 'filter_dc', headerName: 'DC', width: 160 },
        { field: 'route', headerName: 'Route', width: 100 },
        { field: 'door_assigned', headerName: 'Door Assigned?', width: 130 },
        { field: 'pallets_loaded', headerName: 'Pallets Loaded', width: 130, type: 'number' },
        { field: 'pallets_expected', headerName: 'Pallets Expected', width: 140, type: 'number' },
        {
            field: 'loaded_percentage',
            headerName: '% Loaded',
            width: 100,
            type: 'number',
            valueFormatter: (params) => `${params.value || 0}%`
        },
        { field: 'total_pallets', headerName: 'Total Pallets (Smart + Non-smart)', width: 260, type: 'number' },
        { field: 'wrong_door_count', headerName: 'Wrong Door Count', width: 150, type: 'number' },
        { field: 'out_of_order_count', headerName: 'Out of Order Count', width: 160, type: 'number' }
    ];

    return (
        <div style={{ width: '100%' }}>
            <DataGrid
                autoHeight
                rows={enrichedRows}
                columns={columns}
                hideFooter
                disableSelectionOnClick
                getRowId={(row) => row.id}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    routeSummaryData: state.loadValidationDashboard.routeSummaryData,
    filters: state.loadValidationDashboard.filters,
    customers: state.edgePCs.customers || []
});

export default connect(mapStateToProps)(RouteSummaryGridPanel);
